<div class="flex flex-col">
	<div
		[class.bg-primary-2]="entry.selected"
		[matTooltipOptions]="{ delay: [600, 0], arrow: false }"
		[matTooltipTemplate]="tooltipTemplate"
		[matTooltipTemplateContext]="{
      project: entry,
      client: entry.client,
      task: entry.task,
      tags: entry.tags,
    }"
		class="clprj-item flex flex-1 items-center"
		matTooltip
		matTooltipPosition="top-start"
	>
		<mat-list-item
			(click)="onSelect($event)"
			(contextmenu)="onContextMenu($event)"
			(keyup.enter)="onSelect($event)"
			class="cursor-pointer truncate"
			matRippleDisabled
			tabindex="0"
		>
			<div class="flex items-center space-x-2 truncate">
				<div [ngClass]="{ radio: true, active: entry.selected }"></div>
				<span class="truncate"> {{ entry | defaultEntityTranslate: 'project' : 'project.none' }}</span>
			</div>
		</mat-list-item>
		<div class="!ml-auto flex flex-row items-center justify-start gap-1">
			<div
				[style.backgroundColor]="color"
				*ngIf="entry.color as color"
				class="project-color-dot"
			></div>
			<mat-icon
				[matTooltip]="'project.favourite' | translate"
				*ngIf="isPinned$ | async"
				class="bg-accent-2 rounded-circle !p-1"
				color="accent"
				inline
			>
				star
			</mat-icon>
			<div
				*ngIf="!entry.completed && !entry.useAsDefault"
				class="flex flex-shrink-0 flex-row truncate"
			>
				<div
					(click)="!tasksLoading && toggleTasks()"
					class="mat-bg-3-hover flex h-8 cursor-pointer flex-row items-center space-x-0.5 rounded px-2.5 text-sm"
				>
					<ng-container *ngIf="{ count: (tasks$count | async) } as task">
						<span
							>{{ task.count }}
							{{ 'task.plural' | translate }}</span
						>
					</ng-container>
					<ng-container *ngIf="!tasksLoading; else loadingTasksIndicator">
						<mat-icon
							[ngClass]="{ '!rotate-180': showTasks.value }"
							class="!h-initial !leading-none"
							inline
						>
							keyboard_arrow_down
						</mat-icon>
					</ng-container>
				</div>
			</div>
			<button
				(click)="onContextMenu($event)"
				*ngIf="onContextMenu"
				class="!-ml-2"
				mat-icon-button
				tabindex="-1"
			>
				<mat-icon>more_vert</mat-icon>
			</button>
		</div>
	</div>
	<div
		@matScale
		*ngIf="showTasks.value$ | async"
		class="mat-bg-3 mx-1.5 my-2 flex flex-col rounded py-2.5"
	>
		<div
			[style.height.px]="tasksListHeight | async"
			*ngIf="(tasks$count | async) > 0; else noTasksFound"
			class="scroll-y"
		>
			<mat-list-item
				(click)="onSelectTask($event, task)"
				*ngFor="let task of tasks$ | async; trackBy: trackId"
				class="mat-bg-2-hover cursor-pointer truncate"
				matRippleDisabled
				tabindex="0"
			>
				<div class="flex items-center space-x-2 truncate">
					<div [ngClass]="{ radio: true, active: task.selected }"></div>
					<span class="truncate"> {{ task.name }}</span>
				</div>
			</mat-list-item>
		</div>
		<ng-container *ngIf="canCreateTask$ | async">
			<ng-container *ngTemplateOutlet="createTaskButton"></ng-container>
		</ng-container>
	</div>
</div>
<ng-template #loadingTasksIndicator>
	<mat-progress-spinner
		[diameter]="12"
		[strokeWidth]="1"
		class="-mt-1"
		mode="indeterminate"
	></mat-progress-spinner>
</ng-template>
<ng-template #noTasksFound>
	<p
		class="mat-hint text-center text-sm"
		translate
	>
		task.none-found
	</p>
</ng-template>
<ng-template #createTaskButton>
	<div class="mx-1.5 mt-4 flex flex-shrink-0">
		<button
			(click)="createTask($event)"
			class="flex-auto !rounded-lg"
			mat-button
		>
			{{ 'task.add' | translate }}
		</button>
	</div>
</ng-template>
<ng-template
	#defaultTooltip
	let-project="project"
>
	{{ project.name }}
</ng-template>
